import { render } from "./ClinicsActionBar.vue?vue&type=template&id=45c6cd33&ts=true"
import script from "./ClinicsActionBar.vue?vue&type=script&lang=ts"
export * from "./ClinicsActionBar.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__